// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;





import "./App.css";
import { HashRouter, Route, Routes } from "react-router-dom";
import EstimatePage from "./Components/Dashboard.js/EmailEsimate/Emailestimate";
import Login from "./Login/Login";
import PrivateRoute from "./Login/PrivateRoute";
import Dashboard from "./Login/Dashboard/Dashboard";
import ForgotPassword from "./Login/ForgotPassword";


function App() {
return (
<HashRouter>
<Routes>
    <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
           <PrivateRoute>
              <Dashboard />
           </PrivateRoute>
          }
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/estimate/:id" element={<EstimatePage />} />
</Routes>
</HashRouter>
);
}
export default App;